import React from 'react';
import Route from 'react-router/lib/Route';
import Categories from './categories/routes';
import Brands from './brands/routes';
import { ShopProductListRoutes, BarberProductListRoutes, BrandProductListRoutes } from './products/routes';
import PurchaseOrders from './purchaseOrders/routes';
import Layout from './Layout';
import {
  requireProductsViewPermission,
} from '../auth/routerHooks';
import ShrinkageReport from './reports/shrinkage';
import InventoryReport from './reports/inventory';
import ValuationReport from './reports/valuation';
import { BrandShopifyRoutes, ShopShopifyRoutes } from './products/Shopify/routes';

export const ShopProductRoutes = store => (
  <Route path="products" component={Layout} onEnter={requireProductsViewPermission(store)}>
    {Categories(store)}
    {Brands(store)}
    {ShopProductListRoutes(store)}
    {PurchaseOrders(store)}
    <Route path="shrinkage" component={ShrinkageReport} />
    <Route path="inventory" component={InventoryReport} />
    <Route path="valuation" component={ValuationReport} />
    {ShopShopifyRoutes(store)}
  </Route>
);

export const BarberProductRoutes = store => (
  <Route path="products" component={Layout} onEnter={requireProductsViewPermission(store)}>
    {Categories(store)}
    {Brands(store)}
    {BarberProductListRoutes(store)}
    <Route path="shrinkage" component={ShrinkageReport} />
    <Route path="inventory" component={InventoryReport} />
    <Route path="valuation" component={ValuationReport} />
  </Route>
);

export const BrandProductRoutes = store => (
  <Route path="products" component={Layout} onEnter={requireProductsViewPermission(store)}>
    {Categories(store)}
    {Brands(store)}
    {BrandProductListRoutes(store)}
    {PurchaseOrders(store)}
    {BrandShopifyRoutes(store)}
  </Route>
);

